import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel';
import _ from 'lodash';

import { getTaskStatusTabLabel } from 'utils/tasks';

import { TaskTableCellId } from './ConditionTasksTable.constants';

export const prepareTaskRow = task => ({
  id: task.taskId,
  [TaskTableCellId.NAME]: task.name ?? '',
  [TaskTableCellId.LAST_MODIFIED]: task.lastModified,
  [TaskTableCellId.STATUS]: getTaskStatusTabLabel(task.status) ?? '',
  _task: task,
});

export const orderTaskRows = ({ rows, order }) => {
  const direction = order.direction === SORT_DIRECTIONS.DESC ? 'desc' : 'asc';

  return _.orderBy(
    rows,
    row => {
      const value = row[order.id];

      return _.isString(value) ? value.toLowerCase() : value;
    },
    [direction],
  );
};
